import { render, staticRenderFns } from "./MallDueDaysSummary.vue?vue&type=template&id=75ada37c&"
import script from "./MallDueDaysSummary.vue?vue&type=script&lang=ts&"
export * from "./MallDueDaysSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports